module.exports = __webpack_public_path__ + "img/pixing_zc_sunchangdong.43bd78f3.jpg";